export default "__VITE_ASSET__CfIyYZKv__"